export const setWorkspaceLocalStorage = (text) => {
    const result = `Current Workspace: ${text}`;
    localStorage.setItem('workspace-activity', JSON.stringify(result));
}